<template>
    <div class="vx-object-merger">
        <template v-if="hasHeader">
            <slot name="header">
                <label class="vs-input--label" style="padding-left: 0px" v-html="header" />
            </slot>
            <vs-divider></vs-divider>
        </template>
        <div
            class="flex items-center flex-nowrap w-full"
            v-if="hasExistingHeader || hasDuplicateHeader"
        >
            <div class="w-1/5"></div>
            <div class="flex items-center w-4/5">
                <sup class="text-warning w-full mr-10">
                    <small>
                        <slot name="duplicate_header"></slot>
                    </small>
                </sup>
                <sup class="text-warning w-full">
                    <small>
                        <slot name="existing_header"></slot>
                    </small>
                </sup>
            </div>
        </div>
        <vx-property-merger
            v-for="key in commonKeys"
            :key="key"
            :label="getLabel(key)"
            :from="from[key]"
            v-model="to[key]"
        />
    </div>
</template>

<script>
export default {
    name: 'vx-object-merger',
    props: {
        from: {
            type: [Object, Array],
            default: () => {}
        },
        to: {
            type: [Object, Array],
            required: true
        },
        ignoreKeys: {
            type: Array
        },
        customLabels: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {}
    },
    watch: {
        value: {
            get() {
                return this.to
            },
            set(v) {
                this.$emit('input', v)
            }
        }
    },
    computed: {
        hasHeader() {
            return !!this.$slots['header']
        },
        hasDuplicateHeader() {
            return !!this.$slots['duplicate_header']
        },
        hasExistingHeader() {
            return !!this.$slots['existing_header']
        },
        commonKeys() {
            var objectKeys = Object.keys(this.to)
            if (this.ignoreKeys == null || !this.ignoreKeys.any()) {
                return objectKeys
            }
            return objectKeys.where((k) => !this.ignoreKeys.contains(k))
        }
    },
    methods: {
        getLabel(key) {
            if (this.customLabels != null && this.customLabels[key]) {
                return this.customLabels[key]
            }
            return key.capitalize().splitPascalCase()
        }
    },
    mounted() {},
    created() {}
}
</script>

<style lang="scss" scoped></style>
